import { BindAll } from 'lodash-decorators'
import { $service } from '@xt/client/experimental/request/service'
import { action, observable } from 'mobx'
import { EnumApiHome } from '@xt/client/api'

export type ArticleSharingItem = {
  id: number
  jumpUrl: string
  intro: string
  originalUrl: string
  picBigUrl: string
  publishTime: number
  title: string
}

@BindAll()
export class ArticleSharing {
  @observable list: Array<ArticleSharingItem> = []

  public async loadArticleSharing() {
    const [err, data] = await $service<ArticleSharingItem[]>({
      url: EnumApiHome.ArticleRecommend,
      method: 'GET'
    })

    if (err) return

    this.updateList(data)
  }

  @action
  updateList(list: Array<ArticleSharingItem>) {
    this.list = list.slice(0, 2)
  }
}
